import { makeAutoObservable } from 'mobx';
import { fetchElectionAndRegions } from './fn/fetchElectionAndRegions';
import { Election, ElectionAttribute } from '~/definitions/election';
import { getSelectOptionsFromAttribute } from './fn/getSelectOptionsFromAttribute';
import updateElection from './fn/updateElection';
import { onInputChange } from './fn/onInputChange';
import { onChangeSLagId } from './fn/onChangeSLagId';
import { validateForm } from './fn/validateForm';
import { fetchAdminData } from './fn/fetchAdminData';
import { formatSelectOptions } from './fn/formatSelectOptions';
import { getAttributeValue } from './fn/getAttributeValue';
import { getAttributeValueFromOptions } from './fn/getAttributeValueFromOptions';
import { getIsLoading } from './fn/getIsLoading';
import { onChangeElection } from './fn/onChangeElection';
import { copyElection } from './fn/copyElection';
import { getElectionJobPositionCity } from './fn/getElectionJobPositionCity';

export default class AdminStore {
    election: Election | null = null;
    electionToCopy: Election | null = null;
    attributesState: ElectionAttribute[] = [];
    validationErrors: Record<string, boolean> = {};
    shouldShowValidationErrors: boolean = false;

    isCopyElectionModalOpen: boolean = false;
    isLoadingElectionAndRegions: boolean = false;
    isUpdatingElection: boolean = false;
    isCopyingElection: boolean = false;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.election = null;
        this.electionToCopy = null;
        this.attributesState = [];
        this.validationErrors = {};
        this.shouldShowValidationErrors = false;

        this.isCopyElectionModalOpen = false;
        this.isLoadingElectionAndRegions = false;
        this.isUpdatingElection = false;
        this.isCopyingElection = false;
    }

    setElection = (election: typeof this.election) => {
        this.election = election;
    };

    setElectionToCopy = (electionToCopy: typeof this.electionToCopy) => {
        this.electionToCopy = electionToCopy;
    };

    setAttributesState = (attributesState: typeof this.attributesState) => {
        this.attributesState = attributesState;
    };

    setValidationErrors = (validationErrors: typeof this.validationErrors) => {
        this.validationErrors = validationErrors;
    };

    setShouldShowValidationErrors = (shouldShowValidationErrors: typeof this.shouldShowValidationErrors) => {
        this.shouldShowValidationErrors = shouldShowValidationErrors;
    };

    setIsCopyElectionModalOpen = (isCopyElectionModalOpen: typeof this.isCopyElectionModalOpen) => {
        this.isCopyElectionModalOpen = isCopyElectionModalOpen;
    };

    setIsLoadingElectionAndRegions = (isLoadingElectionAndRegions: typeof this.isLoadingElectionAndRegions) => {
        this.isLoadingElectionAndRegions = isLoadingElectionAndRegions;
    };

    setIsUpdatingElection = (isUpdatingElection: typeof this.isUpdatingElection) => {
        this.isUpdatingElection = isUpdatingElection;
    };

    setIsCopyingElection = (isCopyingElection: typeof this.isCopyingElection) => {
        this.isCopyingElection = isCopyingElection;
    };

    getElectionJobPositionCity = getElectionJobPositionCity;
    fetchAdminData = fetchAdminData;
    fetchElectionAndRegions = fetchElectionAndRegions;
    updateElection = updateElection;
    copyElection = copyElection;

    validateForm = validateForm;
    onInputChange = onInputChange;
    getSelectOptionsFromAttribute = getSelectOptionsFromAttribute;
    formatSelectOptions = formatSelectOptions;
    getAttributeValue = getAttributeValue;
    getAttributeValueFromOptions = getAttributeValueFromOptions;
    getIsLoading = getIsLoading;
    onChangeElection = onChangeElection;
    onChangeSLagId = onChangeSLagId;
}
